import { Control, FieldValues, useController, UseControllerProps } from 'react-hook-form';
import FieldWrapper, { FieldWrapperProps } from 'shared/ui/form/fields/field-wrapper';

export type CheckboxFieldVariant = 'primary' | 'secondary';

export interface CheckboxFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<FieldWrapperProps, 'children'> {
  control?: Control<T>;
  labelRight?: string;
  disabled?: boolean;
  className?: string;
  variant?: CheckboxFieldVariant;
  isBold?: boolean;
}

export const CheckboxField = <T extends FieldValues>({
  label,
  required,
  showError,
  labelRight,
  disabled,
  className,
  variant,
  isBold,
  ...props
}: CheckboxFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  const variantClass = variant ? `form-check-${variant}` : '';

  return (
    <FieldWrapper label={label} error={error} required={required} showError={showError}>
      <div className={`form-check ${variantClass} ${className || ''}`.trim()}>
        <input
          id={String(props.name)}
          className="form-check-input"
          type="checkbox"
          checked={!!field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          onBlur={field.onBlur}
          ref={field.ref}
          disabled={disabled}
        />
        {labelRight && (
          <label
            className={`form-check-label ${isBold ? 'fw-bold text-gray-700' : ''}`.trim()}
            htmlFor={String(props.name)}
          >
            {labelRight}
          </label>
        )}
      </div>
    </FieldWrapper>
  );
};
